import { environment } from '@environments/environment';

export function getAddinParameter<T = any>(name: string): T {
  if (environment.addinParameters && environment.addinParameters[name]) {
    return environment.addinParameters[name];
  }

  return {} as any;
}
